// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"430c7ff0","488":"fb245b21","977":"99bdd7a0"}[chunkId] + ".chunk.js";
};